/**
 * Event-outreach details attached to a list (PREC-3520). The fields below become FIXED template
 * tokens ({event_name}, {event_start}, {meeting_link}, …) resolved at send time, so they stay
 * stable across every campaign on the list and survive copying a campaign to another list.
 */

/** Audience a list's event outreach targets (mandatory when enabled). */
export enum ListEventType {
	ATTENDEES = "ATTENDEES",
	EXHIBITORS = "EXHIBITORS",
	MIXED = "MIXED",
}

/** One user-defined event variable: `key` is the token name (e.g. `hall` → `{hall}`). */
export interface ListEventCustomVariable {
	key: string;
	value: string;
}

export interface ListEvent {
	id?: number;
	listId?: number;
	enabled: boolean;
	eventName: string;
	listType: ListEventType;
	/** ISO date strings as serialized by the API. */
	startDate: string;
	endDate: string;
	meetingLocation?: string | null;
	meetingLink?: string | null;
	meetingTimes?: string[] | null;
	customVariables?: ListEventCustomVariable[] | null;
}
